import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  AbstractControl, ValidationErrors, ValidatorFn
} from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { c1, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-button-slider-component",
  templateUrl: "./button-slider-component.component.html",
  styleUrls: ["./button-slider-component.component.scss"],
})
export class ButtonSliderComponentComponent implements OnInit, OnDestroy {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private modalService: BsModalService,
    private builderService: BuilderService
  ) {}

  labelform: UntypedFormGroup; // bootstrap validation form

  @Input() button_id: string;
  @Input() config: any;
  button: MenuButton;
  mode: string;

  // default values
  offCanvasSubscription: any;
  currentMenuSubscription: any;

  offcanvasColors = offcanvasColors;
  newTab = false;
  button_text: string;
  row_id: string;
  labelColor: string;
  black_color: string = "#000000";
  enableCustomColor: boolean = false;
  enableCustomGradientColor: boolean = false;

  button_label_color: string;
  button_label_style: any;
  button_button_divider: number;

  data: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button";
  component_id: string;
  field_id: string;
  modalRef?: BsModalRef;
  icon: any;
  trailing_icon: any;
  iconType: number;
  fontSize = "md";
  density = 0;
  textAlign = "left";
  isAndroid: boolean;
  light: boolean;
  text_id: any;
  colors: any;
  labelDarkColor: any;
  button_color_item: any = { schemes: { light: {}, dark: {} } };
  button_color_light: any = {};
  button_color_dark: any = {};
  sync = true;
  os_name: string;
  fontID: string;
  alginID: string;
  densityID: string;

  startColor: string;
  startDarkColor: string;
  endColor: string;
  endDarkColor: string;
  divider: number;


  ngOnInit() {
    this.field_id = this.config.id;
    this.fontID = this.mdw.makeRef(16);
    this.densityID = this.mdw.makeRef(16);
    this.alginID = this.mdw.makeRef(16);
    this.labelform = this.formBuilder.group({
      min: new UntypedFormControl(0, [Validators.required]),
      max: new UntypedFormControl(100, [Validators.required]),
      step: new UntypedFormControl(1, [Validators.required, this.stepValidator()]),
    }, { validators: this.minLessThanMaxValidator() });

    this.sortedButtonList = [];
    this.buttonList = {};

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button &&
          data.button.button_id == this.button_id
        ) {
          this.buttonIntialize(data);
          this.buttonFunction();
        }
      }
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&   data.off_canvas_key === "button" &&  data.currentButton &&
          this.button_id &&   data.currentButton.button_id == this.button_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];
          this.icon;
          this.buttonFunction();
        }
      }
    );
  }

  buttonIntialize(data) {
    this.data = data.data;

    if (data.button.button_id == this.button_id) {
      this.button = { ...data.button };
      this.component_id = this.button.button_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }

  buttonFunction() {
    if (this.button) {
      this.field_id = this.config.id;
      this.isAndroid =  localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.os_name = this.sync ? null : this.isAndroid ? "Android" : "iOS";

      if (this.config.setcolor){
        this.colors = this.isAndroid
        ? this.config.scheme_color.color_schema
        : this.config.scheme_color.color_schema_ios;
      }
      if (this.isAndroid) {

      } else {

      }

      this.labelform = this.formBuilder.group({
        min: new UntypedFormControl(this.button.button_min || 0, [Validators.required]),
        max: new UntypedFormControl(this.button.button_max ||100, [Validators.required]),
        step: new UntypedFormControl(this.button.button_step ||1, [Validators.required, this.stepValidator()]),
      }, { validators: this.minLessThanMaxValidator() });
      let style = this.isAndroid ? this.button.button_style : this.button.button_style_ios;
      switch(style){
        case '02':
          this.labelform.get('step').enable();
          break;
        default:
          this.labelform.get('step').disable();
          break;

      }
    }
  }

  buttonLabel(key, value) {
    if (this.labelform.valid) {
      this.button[key] = this.f[value].value;
      this.updateButtonData();
    }
  }

  get f() {
    if (this.labelform && this.labelform.controls) {
      return this.labelform.controls;
    }
  }

  minLessThanMaxValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const min = control.get('min')?.value;
        const max = control.get('max')?.value;

        if (min !== null && max !== null && min > max) {
          return { minGreaterThanMax: true }; // Validation error
        }

        return null; // No error
      };
    }

    stepValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const parent = control.parent;
        if (!parent) {
          return null; // Return null if the parent form group is not available
        }

        const min = parent.get('min')?.value;
        const max = parent.get('max')?.value;
        const step = control.value;

        if (min !== null && max !== null && step !== null) {
          const range = max - min;
          if (range % step !== 0) {
            return { invalidStep: true }; // Validation error
          }
        }

        return null; // No error
      };
    }

  updateButtonData() {
    //*must be there in all buttons
    this.buttonList[this.button_id] = this.button;
    let index = this.sortedButtonList[this.button.row_id].findIndex(
      (e) => e.button_id == this.button_id
    );
    this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    this.data["sortedButtonList"] = this.sortedButtonList;
    this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["currentButton"] = this.button;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { button: this.button, tab: { module: "menu" } },
      this.mode,
      true
    );
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
  }
}
